<template>
  <div id="loading-content" class="d-flex align-items-center">
    <div class="loading-message-box ml-auto mr-auto" :class="showClass">
      <svg-viewer
        class="ml-auto mr-auto d-block"
        :src="require('../assets/images/banner/08-cross.svg')"
        width="220px"
        height="220px"
      ></svg-viewer>
      <div class="loading-title">
        Stiamo elaborando i dati immessi, attendere prego
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
export default {
  name: "LoadingPage",
  props: {
    timeout: {
      type: Number,
      default: 2000 //ms
    },
    destination: String,
    showClass: String
  },
  mounted() {
    setTimeout(() => {
      this.$emit("closed", true);
      // console.log('closed');
      if (
        this.destination !== undefined &&
        this.destination !== null &&
        this.destination !== ""
      ) {
        this.goTo(this.destination);
      }
    }, this.timeout);
  },
  methods: {
    goTo(dest) {
      router.push(dest);
    }
  }
};
</script>

<style scoped></style>
